import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import { formatDate } from "../../../../../../../../utils/common";

const Intermediate_Check_Report_Table = ({
  setEdit,
  data,
  currentPage,
  setCurrentPage,
}) => {
  const totalPages = Math.ceil(data.total_pages);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const perPage = data?.per_page || data?.data?.length || 0;

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Date</th>
                <th>Instrument Name</th>
                <th>Instrument ID</th>
                <th>Calibrate By</th>
                <th>Calibrate Instrument By</th>
                <th>Weight in Grams</th>
                <th>STD Value in grams</th>
                <th>Observations</th>
                <th>Mean</th>
                <th>Deviation</th>
                <th>Remark</th>
              </tr>

              {/* <tr>
                  <th>OBS 01</th>
                  <th>OBS 02</th>
                  <th>OBS 03</th>
                  <th>OBS 04</th>
                  <th>OBS 05</th>
                </tr> */}
            </thead>

            <tbody>
              {data?.data && data.data.length > 0 ? (
                data.data.map((row, index) => {
                  const observations =
                    row.Intermediate_Check_Observations || [];

                  return observations.length > 0 ? (
                    observations.map((obs, i) => (
                      <tr key={`${index}-${i}`}>
                        {/* Parent data only once */}
                        {i === 0 && (
                          <>
                            <td rowSpan={observations.length}>
                              {(currentPage - 1) * perPage + index + 1}
                            </td>

                            <td rowSpan={observations.length}>
                              {formatDate(row.createdAt)}
                            </td>

                            <td rowSpan={observations.length}>
                              {row.Instrument_Management?.instrument_name}
                            </td>

                            <td rowSpan={observations.length}>
                              {row.Instrument_Management?.unique_id}
                            </td>
                             <td
                              rowSpan={
                                row.Intermediate_Check_Observations.length
                              }
                            >
                              {row.Calibrated_By?.instrument_name}
                            </td>


                            <td rowSpan={observations.length}>
                              {row.Instrument_Management?.User?.name}
                            </td>
                           
                            <td rowSpan={observations.length}>
                              {row.weight_in_grams}
                            </td>

                            <td rowSpan={observations.length}>
                              {row.std_value_in_grams}
                            </td>
                          </>
                        )}

                        {/* Observation */}
                        <td>
                          OBS {obs.observation_no}{" "}
                          {Number(obs.observation_value || 0).toFixed(2)}
                        </td>

                        {/* Mean & deviation once */}
                        {i === 0 && (
                          <>
                            <td rowSpan={observations.length}>
                              {row.mean_value}
                            </td>

                            <td rowSpan={observations.length}>
                              {row.deviation_value}
                            </td>

                            <td rowSpan={observations.length}>{row.remark}</td>
                          </>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr key={index}>
                      <td>
                        <td>{(currentPage - 1) * perPage + index + 1}</td>
                      </td>
                      <td>{formatDate(row.createdAt)}</td>
                      <td>{row.Instrument_Management?.instrument_name}</td>
                      <td>{row.Instrument_Management?.unique_id}</td>
                      <td>{row.Instrument_Management?.User?.name}</td>
                      <td>{row.weight_in_grams}</td>
                      <td>{row.std_value_in_grams}</td>
                      <td colSpan={3} style={{ textAlign: "center" }}>
                        No Observations
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={10} style={{ textAlign: "center" }}>
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">
            Showing {(data.current_page - 1) * data.per_page + 1} To{" "}
            {Math.min(data.current_page * data.per_page, data.total)} Of{" "}
            {data.total} Entries
          </p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default Intermediate_Check_Report_Table;
